import React from 'react';
import styles from './style.module.scss';
import useResponsive from '~/shared/hooks/useResponsive';
import { useTranslation } from 'next-i18next';

const steps = [
    { id: 1, key: 'profile', image: '✍️' },
    { id: 2, key: 'publish', image: '📂' },
    { id: 3, key: 'payments', image: '💳' },
    { id: 4, key: 'payout', image: '💵' },
];

const InfoSection = () => {
    const { isMobile, isTablet, } = useResponsive();
    const { t } = useTranslation('common');

    return (
        <>
            {' '}
            <div className="mt-5 mx-lg-5">
                <iframe
                    height="300"
                    src={`https://www.youtube.com/embed/RW65MEGen4w?modestbranding=1&showinfo=0&rel=0&controls=1`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                        width: '100%',
                        border: 'none',
                        height: isMobile
                            ? '280px'
                            : isTablet
                                ? '440px'
                                : '640px',
                    }}></iframe>
            </div>
            <section id="steps">
                <div className={styles.titleWrapper}>
                    <img src="/static/img/HomePage/icon.svg" alt="" />
                    <h1>SOFF.UZ</h1>
                    <h3>{t('steps.subtitle')}</h3>
                </div>
                <div className={styles.stepsSection}>
                    {steps.map(step => (
                        <InfoCard
                            img={step?.image}
                            id={step.id}
                            title={t(`steps.items.${step.key}`)}
                        />
                    ))}
                </div>
            </section>
        </>
    );
};

export default InfoSection;

const InfoCard = ({ id, title, subtitle, img }: { id: number, title: string, subtitle?: string, img: string }) => {
    return (
        <div className={styles.stepCard}>
            <div className="d-flex align-items-center gap-2 flex-column">
                <div className={styles.icon}>
                    <span className="d-inline">{img}</span>
                </div>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.subtitle}>{subtitle}</p>
            </div>
            {id == 2 && (
                <img
                    className={styles.two}
                    src={`/static/img/2line.png`}
                    alt="line"
                />
            )}
            {id == 3 && (
                <img
                    className={styles.three}
                    src={`/static/img/3line.png`}
                    alt="line"
                />
            )}
            {id == 4 && (
                <img
                    className={styles.two}
                    src={`/static/img/4line.png`}
                    alt="line"
                />
            )}
        </div>
    );
};
